import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ApiService } from '../../../../core/http/api.service';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/core/auth/auth.service';

@Component({
  selector: 'app-configuration-credits',
  templateUrl: './configuration-credits.component.html',
  styleUrls: ['./configuration-credits.component.css'],
  providers: [MessageService],
})
export class ConfigurationCreditsComponent implements OnInit {
  configId: string = '';
  showConfirmSaveDialog: boolean = false;
  showLoadSkeleton: boolean = false;
  showProgressBar: boolean = false;
  currencyCode: string = '';
  currencyRegional: string = 'es-MX';
  currencySymbol: string = '';
  currencyCodeInput: string = '';
  currencySymbolInput: string = '';
  defaultValues = {
    credit_sell_value: null,
    credit_minimum_sell: null,
    credit_maximum_sell: null,
    credit_minimum_withdraw: null,
    credit_maximum_withdraw: null,
    without_credit_limit: null,
    sendemail_when_sell: null,
    sendemail_when_withdraw: null,
    bonus_maximum_sell: null,
  };
  isButtonDisabled: boolean = true;
  public isPermissionConfiguracionOnly!: boolean;
  formattedCreditValue = '';
  public generalForm: FormGroup = this.formBuilder.group({
    credit_sell_value: [{ value: null, disabled: true }],
    credit_minimum_sell: [null, [Validators.required, Validators.min(1)]],
    credit_maximum_sell: [null, [Validators.required, Validators.min(1)]],
    credit_minimum_withdraw: [null, [Validators.required, Validators.min(1)]],
    credit_maximum_withdraw: [null, [Validators.required, Validators.min(1)]],
    without_credit_limit: [false],
    sendemail_when_sell: [false],
    sendemail_when_withdraw: [false],
    bonus_maximum_sell: [null, [Validators.required, Validators.min(1)]],
  });

  constructor(
    private formBuilder: FormBuilder,
    private api: ApiService,
    private messageService: MessageService,
    private auth: AuthService
  ) {}

  ngOnInit(): void {
    this.setIsPermissionConfiguracionOnly();
    this.getOperatorConfig();
  }

  setIsPermissionConfiguracionOnly() {
    this.isPermissionConfiguracionOnly =
      this.auth.getPermission('Configuración') &&
      !this.auth.getPermission('Editar Casino General') &&
      !this.auth.getPermission('Editar Gestión de Créditos')
        ? true
        : false;
  }

  getOperatorConfig() {
    this.showLoadSkeleton = true;
    this.api.list('operator/operator-config').subscribe((res) => {
      this.defaultValues.credit_sell_value = res.data.sellCreditValue;
      this.defaultValues.credit_minimum_sell = res.data.minimumSellCredit;
      this.defaultValues.credit_maximum_sell = res.data.maximumSellCredit;
      this.defaultValues.credit_minimum_withdraw =
        res.data.minimumWithdrawCredit;
      this.defaultValues.credit_maximum_withdraw =
        res.data.maximumWithdrawCredit;
      this.defaultValues.without_credit_limit =
        res.data.unlimitedWithdrawCredit;
      this.defaultValues.bonus_maximum_sell = res.data.maximumSellBonus;
      this.defaultValues.sendemail_when_sell = res.data.EmailWhenCreditSold;
      this.defaultValues.sendemail_when_withdraw =
        res.data.EmailWhenCreditWithdrawn;
      this.currencyCode = res.data.currencyCode;
      this.currencyCodeInput = ` ${this.currencyCode}`;
      this.currencyRegional = res.data.currencyRegional;
      this.currencySymbol = res.data.currencySymbol;
      this.currencySymbolInput = `${this.currencySymbol} `;
      console.log('RES:', res);
      this.configId = res.data.id;
      this.generalForm
        .get('credit_sell_value')
        ?.setValue(res.data.sellCreditValue);
      this.formattedCreditValue = `${this.currencyCodeInput} ${res.data.sellCreditValue}`;
      this.generalForm
        .get('credit_minimum_sell')
        ?.setValue(res.data.minimumSellCredit);
      this.generalForm
        .get('credit_maximum_sell')
        ?.setValue(res.data.maximumSellCredit);
      this.generalForm
        .get('credit_withdraw_value')
        ?.setValue(res.data.withdrawCreditValue);
      this.generalForm
        .get('credit_minimum_withdraw')
        ?.setValue(res.data.minimumWithdrawCredit);
      this.generalForm
        .get('bonus_maximum_sell')
        ?.setValue(res.data.maximumSellBonus);
      this.generalForm
        .get('credit_maximum_withdraw')
        ?.setValue(res.data.maximumWithdrawCredit);
      this.generalForm
        .get('without_credit_limit')
        ?.setValue(res.data.unlimitedWithdrawCredit);
      this.generalForm
        .get('sendemail_when_sell')
        ?.setValue(res.data.EmailWhenCreditSold);
      this.generalForm
        .get('sendemail_when_withdraw')
        ?.setValue(res.data.EmailWhenCreditWithdrawn);
      this.showLoadSkeleton = false;

      if (!this.canEdit()) {
        this.generalForm.disable();
      }
    });
  }

  changeSelect() {
    if (this.generalForm.get('without_credit_limit')?.value) {
      this.generalForm.get('credit_maximum_withdraw')?.disable();
      if (
        this.defaultValues.credit_minimum_sell ===
          this.generalForm.get('credit_minimum_sell')?.value &&
        this.defaultValues.credit_maximum_sell ===
          this.generalForm.get('credit_maximum_sell')?.value &&
        this.defaultValues.bonus_maximum_sell ===
          this.generalForm.get('bonus_maximum_sell')?.value &&
        this.defaultValues.credit_minimum_withdraw ===
          this.generalForm.get('credit_minimum_withdraw')?.value /*
        this.defaultValues.credit_maximum_withdraw === this.generalForm.get("credit_maximum_withdraw")?.value &&*/ &&
        this.defaultValues.without_credit_limit ===
          this.generalForm.get('without_credit_limit')?.value &&
        this.defaultValues.sendemail_when_sell ===
          this.generalForm.get('sendemail_when_sell')?.value &&
        this.defaultValues.sendemail_when_withdraw ===
          this.generalForm.get('sendemail_when_withdraw')?.value
      ) {
        this.isButtonDisabled = true;
      } else {
        if (this.generalForm.valid) {
          this.isButtonDisabled = false;
        } else {
          this.isButtonDisabled = true;
        }
      }
    } else {
      this.generalForm.get('credit_maximum_withdraw')?.enable();
      if (
        this.defaultValues.credit_minimum_sell ===
          this.generalForm.get('credit_minimum_sell')?.value &&
        this.defaultValues.credit_maximum_sell ===
          this.generalForm.get('credit_maximum_sell')?.value &&
        this.defaultValues.credit_minimum_withdraw ===
          this.generalForm.get('credit_minimum_withdraw')?.value &&
        this.defaultValues.credit_maximum_withdraw ===
          this.generalForm.get('credit_maximum_withdraw')?.value &&
        this.defaultValues.bonus_maximum_sell ===
          this.generalForm.get('bonus_maximum_sell')?.value &&
        this.defaultValues.without_credit_limit ===
          this.generalForm.get('without_credit_limit')?.value &&
        this.defaultValues.sendemail_when_sell ===
          this.generalForm.get('sendemail_when_sell')?.value &&
        this.defaultValues.sendemail_when_withdraw ===
          this.generalForm.get('sendemail_when_withdraw')?.value
      ) {
        this.isButtonDisabled = true;
      } else {
        if (this.generalForm.valid) {
          this.isButtonDisabled = false;
        } else {
          this.isButtonDisabled = true;
        }
      }
    }
  }

  save() {
    this.showConfirmSaveDialog = true;
    const data = {
      sellCreditValue: this.generalForm.get('credit_sell_value')?.value,
      minimumSellCredit: this.generalForm.get('credit_minimum_sell')?.value,
      maximumSellCredit: this.generalForm.get('credit_maximum_sell')?.value,
      minimumWithdrawCredit: this.generalForm.get('credit_minimum_withdraw')
        ?.value,
      maximumWithdrawCredit: this.generalForm.get('credit_maximum_withdraw')
        ?.value,
      unlimitedWithdrawCredit: this.generalForm.get('without_credit_limit')
        ?.value,
      maximumSellBonus: this.generalForm.get('bonus_maximum_sell')?.value,
      EmailWhenCreditSold: this.generalForm.get('sendemail_when_sell')?.value,
      EmailWhenCreditWithdrawn: this.generalForm.get('sendemail_when_withdraw')
        ?.value,
    };
    this.showProgressBar = true;
    this.api.updateDirect('operator/operator-config', data).subscribe({
      next: (res) => {
        if (res.statusCode === 200) {
          this.messageService.add({
            key: 'tc',
            severity: 'success',
            summary: 'Cambios aplicados satisfactoriamente',
          });
          this.getOperatorConfig();
          this.showProgressBar = false;
        }
        //this.toastService.openSuccessToast('Cambios aplicados satisfactoriamente', () => {}, () => {});
        this.showConfirmSaveDialog = false;
      },
      error: (err) => {
        console.error(err);
        this.messageService.add({
          key: 'tc',
          severity: 'error',
          summary: 'Ocurrió un error al intentar aplicar los cambios',
        });
        this.showProgressBar = false;
      },
    });
  }

  closeDialog = () => {
    this.showConfirmSaveDialog = false;
    document.body.classList.add('p-overflow-hidden');
  };

  showDialog = () => {
    if (this.generalForm.get('without_credit_limit')?.value) {
      if (
        this.generalForm.get('credit_minimum_sell')?.value >
        this.generalForm.get('credit_maximum_sell')?.value
      ) {
        this.messageService.add({
          key: 'tc',
          severity: 'error',
          summary:
            'Verifica los valores mínimos y máximos para tus ventas y retiros',
        });
      } else {
        this.showConfirmSaveDialog = true;
      }
    } else {
      if (
        this.generalForm.get('credit_minimum_sell')?.value >
          this.generalForm.get('credit_maximum_sell')?.value ||
        this.generalForm.get('credit_minimum_withdraw')?.value >
          this.generalForm.get('credit_maximum_withdraw')?.value
      ) {
        this.messageService.add({
          key: 'tc',
          severity: 'error',
          summary:
            'Verifica los valores mínimos y máximos para tus ventas y retiros',
        });
      } else {
        this.showConfirmSaveDialog = true;
      }
    }

    // if(this.generalForm.get("sendemail_when_sell")?.value || this.generalForm.get("sendemail_when_withdraw")?.value)
    // {
    //   this.showConfirmSaveDialog = true;
    // }
  };

  //changeWhitdrawLimit = (e: any) => e === true ? this.withoutLimit = true : this.withoutLimit = false;

  canEdit() {
    return this.auth.getPermission('Editar Gestión de Créditos');
  }
}
